<app-loading-spinner *ngIf="loadingSpinnerService.loading$ | async"></app-loading-spinner>

<div class="tab-content orders-main">
  <div class="header">
    <div class="header-left">
      <div class="input-container d-flex">
        <select class="form-select" style="max-width: 212px; margin-right: 8px; color: rgb(0, 131, 172);"
          [value]="filterMode" (change)="onFilterModeChange($event)">
          <option value="today">Today</option>
          <option value="month">This Month</option>
          <option value="range1">Custom</option>
          <option value="range" [hidden]="filterMode !== 'range'">{{ selectedRangeText || 'Custom Range' }}</option>
        </select>
        <input style="visibility: hidden; position: absolute; left: 0;" #dateInput type="text" class="main-date"
          id="birthday-date" name="birthday-date" [ngClass]="{ 'd-none': filterMode === 'today' }"
          [placeholder]="(filterMode === 'range' || filterMode === 'month') ? 'Select date range' : 'Select a date'"
          [value]="(filterMode === 'range' || filterMode === 'month') ? selectedRangeText : ''"
          (change)="onDateChange($event)" (click)="onDateInputClick()" />
        <div class="dropdown" data-bs-auto-close="outside" style="margin-left: 8px;" *ngIf="allLocations?.length > 1">
          <button #locationFilterDropdown class="btn btn-outline-secondary dropdown-toggle" type="button" id="locationFilterDropdown"
            data-bs-toggle="dropdown" aria-expanded="false">
            <!-- {{ allLocationsSelected ? 'Playgrounds' : (selectedLocationIds.length + ' selected') }} -->
            Playgrounds
          </button>
          <ul class="dropdown-menu p-0" aria-labelledby="locationFilterDropdown"
            style="min-width: 300px; border-radius: 8px;" (click)="$event.stopPropagation()">
            <div class="dropdown-scroll-container">
              <li class="search-wrapper">
                <input type="text" class="form-control location-search" placeholder="Search playgrounds..." 
                  [(ngModel)]="locationSearchTerm" (click)="$event.stopPropagation()" />
              </li>
              <li>
                <div class="form-check">
                  <label class="form-check-label" for="allLocationsCheck">All</label>
                  <input class="form-check-input" type="checkbox" id="allLocationsCheck" [checked]="allLocationsSelected"
                    (change)="toggleAllLocations($event.target.checked)" />
                </div>
              </li>
              <li *ngFor="let location of getFilteredLocations()">
                <div class="form-check">
                  <label class="form-check-label" [for]="'loc_' + location.id">{{ location.name }}</label>
                  <input class="form-check-input" type="checkbox" [id]="'loc_' + location.id"
                    [checked]="tempSelectedLocationIds.includes(location.id)"
                    (change)="toggleLocationSelection(location.id, $event.target.checked)" />
                </div>
              </li>
              <li *ngIf="getFilteredLocations().length === 0" class="no-results">
                <span>No playgrounds found</span>
              </li>
            </div>
            <li class="dropdown-footer">
              <button class="btn-apply" type="button" (click)="applyLocationFilter()"
                [disabled]="tempSelectedLocationIds.length === 0">Apply</button>
            </li>
          </ul>
        </div>

        <!-- Status Filter (mirror location filter: multi-select + Apply) -->
        <div class="dropdown" data-bs-auto-close="outside" style="margin-left: 8px;" *ngIf="isFunCityPlayground">
          <button #statusFilterDropdown class="btn btn-outline-secondary dropdown-toggle" type="button" id="statusFilterDropdown"
            data-bs-toggle="dropdown" aria-expanded="false">
            <!-- {{ getStatusFilterLabel() }}  -->
            Statuses
          </button>
          <ul class="dropdown-menu p-0" aria-labelledby="statusFilterDropdown"
            style="min-width: 200px; border-radius: 8px;" (click)="$event.stopPropagation()">
            <div class="dropdown-scroll-container">
              <li>
                <div class="form-check">
                  <label class="form-check-label" for="allStatusesCheck">All</label>
                  <input class="form-check-input" type="checkbox" id="allStatusesCheck" [checked]="allStatusesSelected"
                    (change)="toggleAllStatuses($event.target.checked)" />
                </div>
              </li>
              <li *ngFor="let status of statusOptions" [ngClass]="{ 'd-none': status.value === 'all' }">
                <div class="form-check">
                  <label class="form-check-label" [for]="'status_' + status.value">{{ status.label }}</label>
                  <input class="form-check-input" type="checkbox" [id]="'status_' + status.value"
                    [checked]="tempSelectedStatuses.includes(status.value)"
                    (change)="toggleStatusSelection(status.value, $event.target.checked)" />
                </div>
              </li>
            </div>
            <li class="dropdown-footer">
              <button class="btn-apply" type="button" (click)="applyStatusFilter()"
                [disabled]="!allStatusesSelected && tempSelectedStatuses.length === 0">Apply</button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <button class="hover-button" type="button" data-bs-toggle="collapse" data-bs-target="#orderExpand"
      aria-expanded="false" aria-controls="orderExpand">
      + Create new birthday
    </button>
  </div>
  <!-- Empty state -->
  <div class="magnets-count" *ngIf="hasMagnetsProperties()">
    <div>
      <span *ngIf="getMagnetsLabel()">{{ getMagnetsLabel() }}</span>
      Celebrant Magnets: <b>{{ totalCelebrantMagnets > 0 ? totalCelebrantMagnets : 0 }}</b> | Return Gift Magnets: <b>{{ totalReturnGiftMagnets > 0 ? totalReturnGiftMagnets : 0 }}</b>
    </div>
  </div>
    <div class="text-center empty-state" *ngIf="!hasVisibleBirthdays()">
      <img src="../../assets/images/empty-birthday.svg" alt="" />
      <h2>There’s no birthdays, yet</h2>
      <p>
        Managing your birthdays is super simple, so, why don’t you start creating
        now?
      </p>

      <button class="hover-button create-btn" type="button" data-bs-toggle="collapse" data-bs-target="#orderExpand"
        aria-expanded="false" aria-controls="orderExpand">
        <img src="../../assets/images/add.svg" alt="" /> Create new birthday
      </button>
    </div>

    <div class="cards-wrapper">
      <div *ngFor="let dateGroup of groupedData; let i = index" [ngClass]="i === 0 ? 'mt-2' : 'mt-5'">
        <div *ngIf="dateGroup.locations.length > 0 && hasVisibleBirthdaysInDateGroup(dateGroup)">
          <h3 class="mb-0">{{ dateGroup.date }}</h3>
          <div>
            <div *ngFor="let loc of dateGroup.locations" class="mt-3">
              <h4 class="mb-0" *ngIf="loc.birthdays.length > 0">{{ loc.name }}</h4>
              <div class="row">
                <div *ngFor="let birthday of loc.birthdays" class="col-md-4 mt-2">
                  <app-birthday-card (openEditForm)="expandFormWithCardData($event)" [birthday]="birthday">
                  </app-birthday-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="collapse collapse-horizontal orders" id="orderExpand" #orderExpand
      (shown.bs.collapse)="toggleBackdrop(true)" (hidden.bs.collapse)="toggleBackdrop(false)">
      <div class="orders-top">
        <h3>{{ editMode ? 'Edit' : 'New' }} birthday</h3>
        <div>
          <button data-bs-toggle="collapse" data-bs-target="#orderExpand">
            <img src="../../assets/images/close-notification.svg" alt="" />
          </button>
        </div>
      </div>

      <div class="orders-bottom">
        <form class="d-flex flex-column justify-content-between h-100" (ngSubmit)="bookBirthday()"
          [formGroup]="addBirthdayForm">
          <div>
            <div class="mb-3 input-wrapper d-flex justify-content-between gap-2">
              <!-- Option 1 -->
              <label class="option-label" for="option1">
                <div class="option-box option1" [class.selected]="selectedValue === 'male'">
                  Boy’s Birthday
                </div>
              </label>
              <input style="visibility: hidden; width: 0px;" type="radio" id="option1" name="choice"
                formControlName="choice" value="male" (change)="selectOption('male')" />

              <!-- Option 2 -->
              <label class="option-label" for="option2">
                <div class="option-box option2" [class.selected]="selectedValue === 'female'">
                  Girl’s Birthday
                </div>
              </label>
              <input style="visibility: hidden ; width: 0px;" type="radio" id="option2" formControlName="choice"
                name="choice" value="female" (change)="selectOption('female')" />
            </div>

            <div class="mb-3 input-wrapper d-flex location-room flex-wrap justify-content-between gap-1">
              <div class="p-0 date-item">
                <label class="form-label">Date</label><br />
                <div class="input-container d-flex p-0">
                  <input #dateInput2 type="text" class="main-date" formControlName="selectDateForm" [min]="minDate"
                    style="padding: 10px;" />
                  <img src="../../../assets/images/calendar.svg" class="calendar-icon" alt="calendar"
                    (click)="openCalendar2()" />
                </div>
              </div>

              <!-- Playground Selection - Always visible if multiple playgrounds exist -->
              <div class="p-0 date-item" *ngIf="managedPlaygrounds?.length > 1">
                <label class="form-label">Choose playground</label><br />
                <select class="form-select" formControlName="playground" (change)="onPlaygroundChange($event)">
                  <option *ngFor="let playground of managedPlaygrounds" [value]="playground.uid">
                    {{ playground.fullName }}
                  </option>
                </select>
              </div>

              <!-- Location Selection - Only visible after playground is selected -->
              <div class="p-0 date-item" *ngIf="selectedPlaygroundId && formLocations?.length > 1">
                <label class="form-label">Choose location</label><br />
                <select class="form-select" formControlName="location" (change)="onLocationChange($event)">
                  <option *ngFor="let location of formLocations" [value]="location.id">
                    {{ location.name }}
                  </option>
                </select>
              </div>

              <!-- Room Selection - Only visible after location is selected -->
              <div class="p-0 date-item" *ngIf="selectedLocation && filteredRooms?.length > 1">
                <label class="form-label">Choose room</label><br />
                <select formControlName="room" class="form-select" (change)="onRoomChange($event)">
                  <option *ngFor="let room of filteredRooms" [value]="room.id">
                    {{ room.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="mb-3 input-wrapper" *ngIf="editMode">
              <label class="form-label">Status</label>
              <div class="status-label d-flex align-items-center" [ngStyle]="{
                'background-color':
                  birthdayCard?.orderStatus === 'waiting_confirmation' ? '#FFB443' :
                  birthdayCard?.orderStatus === 'cancelled' ? 'rgba(234, 84, 64, 1)' :
                  birthdayCard?.orderStatus === 'generic_magnet' ? 'rgba(139, 92, 246, 1)' : 'rgba(38, 166, 154, 1)'
              }">
                {{
                birthdayCard?.orderStatus === 'waiting_confirmation' ? 'Reserved' :
                birthdayCard?.orderStatus === 'order_completed' ? 'Personalized (Delivered)' :
                birthdayCard?.orderStatus === 'cancelled' ? 'Cancelled' :
                birthdayCard?.orderStatus === 'generic_magnet' ? 'Generic' : 'Personalized'
                }}
                <img *ngIf="birthdayCard?.orderStatus === 'order_completed'"
                  src="../../../assets/images/delivered-form.svg" width="18" height="18" class="ms-2" alt="">
              </div>
            </div>

            <div *ngIf="reservedBirthdaysForm.length > 0; else noReserved">
              <div class="mb-3 input-wrapper">
                <label class="form-label">Reserved birthdays</label><br />
                <span *ngFor="let time of reservedBirthdaysForm" class="reserved-time">
                  {{ time.start }} - {{ time.end }}
                </span>
              </div>
            </div>

            <ng-template #noReserved>
              <p style="font-size: 16px; color: rgb(114, 114, 114); font-weight: 700; text-align: left;">No birthday
                reserved</p>
            </ng-template>

            <div class="mb-3 input-wrapper d-flex justify-content-between input-time gap-2">
              <div>
                <label class="form-label">Birthday name </label>
                <input formControlName="name" type="text" placeholder="ex. Mario" class="form-control" />
              </div>
              <div>
                <label class="form-label">Age </label>
                <input formControlName="age" type="number" placeholder="ex. 12" class="form-control" />
              </div>
              <div>
                <label class="form-label">No. of kids </label>
                <input formControlName="numberOfKids" type="number" placeholder="ex. 24" class="form-control" />
              </div>
            </div>

            <div class="mb-3 input-wrapper d-flex justify-content-between input-time">
              <div>
                <label class="form-label">Start time </label>
                <input type="time" placeholder="ex. 14:00" class="form-control" formControlName="startTime"
                  (change)="onStartTimeChange($event)" [ngClass]="{'border-red': isTimeConflict()}" #startTimeInput />
              </div>
              <div>
                <label class="form-label">End time </label>
                <input type="time" placeholder="ex. 16:00" class="form-control" formControlName="endTime"
                  (change)="onEndTimeChange($event)" [ngClass]="{'border-red': isTimeConflict()}" #endTimeInput />
              </div>
            </div>

            <div class="mb-3 input-wrapper">
              <label for="orderNote" class="form-label">Add a note <span class="fw-normal">(optional)</span>
              </label>
              <textarea class="form-control" id="orderNote" rows="3" placeholder="Short description"
                formControlName="orderNote" maxlength="140"></textarea>

              <div class="text-danger"></div>

              <span class="text-limit">max 140</span>
            </div>
            <div class="mb-3 input-wrapper" *ngIf="isReadOnly && cancellationReason">
              <label for="orderNote" class="form-label">Cancelation message
              </label>
              <p class="text-start">{{cancellationReason}}</p>
            </div>
            <div class="mb-3 input-wrapper" *ngIf="!isReadOnly">
              <div *ngIf="birthdayCard?.shouldGeneratePaymentLink">
                <ng-container *ngIf="!birthdayCard?.paymentLink; else showPaymentLink">
                  <button type="button" class="payment-btn" (click)="onGeneratePaymentLink()"
                    [disabled]="isGeneratingPaymentLink">
                    {{ isGeneratingPaymentLink ? 'Generating…' : 'Generate Payment Link' }}
                  </button>
                </ng-container>
                <ng-template #showPaymentLink>
                  <div class="d-flex align-items-center justify-content-between copy-link">
                    <div class="d-flex align-items-center">
                      <img src="../../../assets/images/copy-link.svg" class="me-2" alt="">
                      <p (click)="copyPaymentLink(birthdayCard?.paymentLink)">
                        {{ birthdayCard?.paymentLink }}
                      </p>
                    </div>
                    <button type="button" class="hover-button ms-2"
                      (click)="copyPaymentLink(birthdayCard?.paymentLink)">Copy</button>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="submit-wrapper d-flex justify-content-between" *ngIf="!isReadOnly">
            <div>
              <button type="submit" class="submit-btn hover-button" [innerText]="editMode ? 'Save' : 'Create' "
                [disabled]="addBirthdayForm.invalid">Create</button>
              <button type="button" class="cancel-btn" data-bs-toggle="collapse" data-bs-target="#orderExpand">
                Cancel
              </button>
            </div>
            <button type="button" class="delete-btn hover-button" data-bs-toggle="modal"
              data-bs-target="#deleteGiftCardModal" *ngIf="!isFunCityPlayground"
              [ngClass]="{ 'd-none': !editMode }">Delete birthday</button>
            <button type="button" class="delete-btn hover-button" data-bs-toggle="modal"
              data-bs-target="#cancelBirthdayModal" *ngIf="isFunCityPlayground"
              [ngClass]="{ 'd-none': !editMode }">Cancel
              birthday</button>
          </div>
        </form>
      </div>
    </div>
    <div class="sidebar-backdrop" data-bs-toggle="collapse" data-bs-target="#orderExpand" #backdrop></div>
  </div>

  <!-- Delete Confirmation Modal -->
  <div class="modal fade delete-gc-modal" #birthdayDelete id="deleteGiftCardModal" tabindex="-1"
    aria-labelledby="deleteGiftCardLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteGiftCardLabel">Delete birthday</h5>
        </div>
        <div class="modal-body">
          Are you sure that you want to delete this birthday?
        </div>
        <div class="modal-footer">
          <button type="button" class="hover-button" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="hover-button" (click)="deleteCard()">Delete</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade delete-gc-modal" #cancelBirthdayModal id="cancelBirthdayModal" tabindex="-1"
    aria-labelledby="cancelBirthdayLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="cancelBirthdayLabel">Cancel birthday</h5>
        </div>
        <div class="modal-body">
          Please provide the reason for canceling this birthday.
          <textarea [(ngModel)]="cancelReason" #cancelMessage class="form-control mt-2" rows="3"
            placeholder="Cancellation reason"></textarea>
        </div>
        <div class="modal-footer">
          <button type="button" class="hover-button" data-bs-dismiss="modal">Dismiss</button>
          <!-- <button type="button" class="hover-button main-cancel" (click)="cancelBirthday(birthdayCard.uid)" [disabled]="!cancelMessage.value || !cancelMessage.value.trim().length">Cancel Birthday</button> -->
          <button type="button" class="hover-button main-cancel" (click)="cancelBirthday(birthdayCard.uid)"
            [disabled]="!cancelReason || !cancelReason.trim().length">
            Cancel Birthday
          </button>
        </div>
      </div>
    </div>
  </div>



  <!-- Toast container -->
  <!-- Add #birthdayToast reference -->
  <div #birthdayToast class="toast align-items-center text-bg-success border-0" role="alert" aria-live="assertive"
    aria-atomic="true">
    <div class="d-flex">
      <div class="toast-body">
        Birthday created successfully!
      </div>
    </div>
  </div>